/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recentsales_Title1Inputs */

const he_dashboard_recentsales_title1 = /** @type {(inputs: Dashboard_Recentsales_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מכירות אחרונות`)
};

const en_dashboard_recentsales_title1 = /** @type {(inputs: Dashboard_Recentsales_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Sales`)
};

/**
* | output |
* | --- |
* | "Recent Sales" |
*
* @param {Dashboard_Recentsales_Title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_recentsales_title1 = /** @type {((inputs?: Dashboard_Recentsales_Title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recentsales_Title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_recentsales_title1(inputs)
	return en_dashboard_recentsales_title1(inputs)
});
export { dashboard_recentsales_title1 as "dashboard_recentSales_title" }